const state = {
  sidebarContactFilter: null,
  editFilter: null,
};

const mutations = {
  SET_SIDEBAR_CONTACT_FILTER(state, filter) {
    state.sidebarContactFilter = filter;
  },
  SET_EDIT_FILTER(state, filter) {
    state.editFilter = filter;
  },
  CLEAR_SIDEBAR_CONTACT_FILTER(state) {
    state.sidebarContactFilter = null;
  },
  CLEAR_EDIT_FILTER(state) {
    state.editFilter = null;
  },
};

const actions = {
  setSidebarContactFilter({ commit }, filter) {
    commit('SET_SIDEBAR_CONTACT_FILTER', filter);
  },
  setEditFilter({ commit }, filter) {
    commit('SET_EDIT_FILTER', filter);
  },
  clearSidebarContactFilter({ commit }) {
    commit('CLEAR_SIDEBAR_CONTACT_FILTER');
  },
  clearEditFilter({ commit }) {
    commit('CLEAR_EDIT_FILTER');
  },
};

const getters = {
  sidebarContactFilter: (state) => state.sidebarContactFilter,
  editFilter: (state) => state.editFilter,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
